import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { essilorLogo } from '@Techedge/digitalportal-styleguide'
import {
    LuxLoadingCircle,
    LuxButton,
    LuxHeading,
} from '@Techedge/digitalportal-wardrobe'
import { history } from '@Techedge/digitalportal-shared'
import { envLinks, nodeEnv } from '../Techedge-digitalportal-home'
import '../digital-portal.scss'
import apm from '@Techedge/digitalportal-root'

const HomePage = ({ accessToken, portals }) => {
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!!portals && !!accessToken) {
            let _portals = [...portals]
            let idx = _portals.findIndex((p) => p.code === process.env.EXCLUDED_PORTAL)
            if (idx > -1) _portals.splice(idx, 1)
            if (_portals.length === 1) goTo(_portals[0].url, _portals[0].code)
            else if (_portals.length === 0) {
                window.location.href = envLinks.DP + '/login_error_noportals'
            } else setLoading(false)
        }
    }, [portals, accessToken])

    const goTo = (url: string, code: string) => {
        // Add button click transaction to trace which portal gets selected by the user
        const transaction = apm.startTransaction('portal-selection', 'custom', {
            managed: true,
        })
        if (transaction) {
            if (code === '360°' || code === 'SMRT') {
                transaction.addLabels({ ['portal']: 'SMARTLY' })
            } else {
                transaction.addLabels({ ['portal']: code })
            }
            const span = transaction.startSpan(
                'portal-selection-time',
                'app-load',
                { blocking: true }
            )
            span.end(span._start + 1)
            // Ritarda il redirect per permettere il completamento della transazione
            setTimeout(() => {
                transaction.end()

                const redirectUrl =
                    nodeEnv && nodeEnv !== 'production'
                        ? envLinks[code] + '?jwt=' + accessToken
                        : url + '?jwt=' + accessToken

                window.location.href = redirectUrl
            }, 150) // 125ms di ritardo per inviare i dati APM
        } else {
            if (nodeEnv && nodeEnv !== 'production')
                window.location.href = envLinks[code] + '?jwt=' + accessToken
            else window.location.href = url + '?jwt=' + accessToken
        }
    }

    return (
        <div className="portal-container flex-center">
            <LuxButton
                icon={' cu cu-logout'}
                variant={['text']}
                text="Logout"
                classes="logout-btn"
                onClick={() => history.push('/logout')}
            />
            <img className="logo-bg" src={essilorLogo} />
            <img className="logo" src={essilorLogo} />

            {!(window.location.pathname === '/logout') &&
            !loading &&
            portals?.length > 1 ? (
                <div className="flex-center">
                    <LuxHeading type="h1">
                        Please select your web portal
                    </LuxHeading>
                    <div className="btn-container">
                        {portals.map((p, i) => {
                            if (p.code !== 'SMRT')
                                return (
                                    <button
                                        key={i}
                                        className="webportal-btn"
                                        onClick={() => goTo(p.url, p.code)}>
                                        {p.name}
                                    </button>
                                )
                            else return <></>
                        })}
                    </div>
                </div>
            ) : (
                <div>
                    <LuxLoadingCircle active={true} />
                </div>
            )}
            {!loading && !portals && (
                <LuxHeading type="h1">Something went wrong</LuxHeading>
            )}
        </div>
    )
}

const mapStateToProps = (state) => ({
    accessToken: state.userReducer.accessToken,
    portals: state.userReducer.permissions?.portals,
})

export default connect(mapStateToProps, () => ({}))(HomePage)
